const TMC_X_CARD_DIGITS = 10;

export function projectTmcXBadge(badge: string): string | null {
  const trimmed = badge.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  const significant = trimmed.replace(/^0+/, '');
  if (significant.length > TMC_X_CARD_DIGITS) return null;
  return significant.padStart(TMC_X_CARD_DIGITS, '0');
}
